import { useState } from "react";
import Modal from "../../../components/modal";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import ChooseAnotherWinner from "./chooseAnotheWinner";
import winnerIcon from '../../../statics/img/icons/chico.png'
import { setWinner, getWinner } from "../../../store/raffle";

export default function WinnerSelected({ setTab }: any) {
  const [isOpen, setIsOpen] = useState(false)
  const { numberOfWinners } = useAppSelector((state) => state.sweepstakes)
  const { winnerInfo, raffleInfo, status } = useAppSelector((state) => state.raffle)
  const [newWinner, setNewWinner] = useState(false)
  const [startDate, setStartDate] = useState(raffleInfo ? new Date(raffleInfo.start_date) : new Date())
  const [endDate, setEndDate] = useState(raffleInfo ? new Date(raffleInfo.end_date) : new Date())
  const dispatch = useAppDispatch()
  const actualDate = new Date()

  // const pickAnotherWinner = () => {
  //   setIsOpen(true)
  // }

  // const getNewWinner = () => {
  //   setNewWinner(true)
  // }


  const saveWinner = () => {
    const winner = {
      id_raffle: raffleInfo.id_encrypted,
      id_lead: winnerInfo.id_encrypted,
      status: 1,
      status_message: "Winner"
    }
    dispatch(setWinner(winner))
  }

  const getWinnerFunction = () => {
    const winner = {
      start_date: startDate.toISOString().slice(0,-14),
      end_date: endDate.toISOString().slice(0,-14),
      repeat_winners: 0
    }
    console.log(winner)
    dispatch(getWinner(winner)).then(res => {
      // setTab((prev: any) => prev + 1)
    })
  }


  return (<>
    <Modal
      isActive={isOpen}
      clouse={() => setIsOpen(false)}>
      <ChooseAnotherWinner setIsOpen={setIsOpen} />
    </Modal>
    {(numberOfWinners === 1) &&
      <div className="c-winner-management-winnerSelected">
        <div className="c-winner-management-winnerSelected-info">
          <div className="winnerInfo">
            <div className="avatar">
              <div className="image">
                <img src={winnerIcon} alt="" />
              </div>
            </div>
            <div className="info">
              <h1>Winner!</h1>
              <h3>{winnerInfo.first_name} {winnerInfo.last_name}</h3>
              <p>{winnerInfo.city ? `${winnerInfo.city},` : ' '} {winnerInfo.State || ' '} {winnerInfo.zip_code || ' '}</p>
              <p>{winnerInfo.email}</p>
              <p>{winnerInfo.phone}</p>
            </div>
          </div>
          <div className="raffleInfo">
            {/* <p>Total Valid Names:  10000</p> */}
            <p>{`Date: ${actualDate.getMonth() + 1}-${actualDate.getDate()}-${actualDate.getFullYear()}`}</p>
          </div>
        </div>
        {
          (status !== 'setWinner_success') &&
          <div className="c-winner-management-winnerSelected-buttons">
            <button className="buttonwinner buttonOrangeWinner" onClick={getWinnerFunction}>Pick Another Winner</button>
            <button className="buttonwinner buttonBlueWinner" onClick={saveWinner}>Notify Winner!</button>
          </div>
        }
      </div>
    }
    {/* {(numberOfWinners > 1) &&
      <div className="c-winner-management-winnerSelected">
        <div className="c-winner-management-winnerSelected-info small">
          <div className="winnerInfo">
            <div className="avatar">
              <div className="image">
                <img src={winnerIcon} alt="" />
              </div>
            </div>
            <div className="info">
              <h1>Winner Nº 1</h1>
              <h3>Robert Junior</h3>
              <p>Los Angeles, CA</p>
              <p>rjunion@email.com</p>
              <p>714-123-1234</p>
            </div>
          </div>
          <div className="raffleInfo">
            <p>Total Valid Names:  10000</p>
            <p>Date: 10-10-2022</p>
          </div>
        </div>
        {
          (newWinner) &&
          <div className="c-winner-management-winnerSelected-info">
            <div className="winnerInfo">
              <div className="avatar">
                <div className="image">
                  <img src={winnerIcon} alt="" />
                </div>
              </div>
              <div className="info">
                <h1>Winner! Nº 2</h1>
                <h3>Robert Junior</h3>
                <p>Los Angeles, CA</p>
                <p>rjunion@email.com</p>
                <p>714-123-1234</p>
              </div>
            </div>
            <div className="raffleInfo">
              <p>Total Valid Names:  10000</p>
              <p>Date: 10-10-2022</p>
            </div>
          </div>
        }
        <div className="c-winner-management-winnerSelected-buttons">
          <button className="buttonwinner buttonOrangeWinner" onClick={pickAnotherWinner}>Pick Another Winner</button>
          <button className="buttonwinner buttonBlueWinner" onClick={getNewWinner}>Get Next Winner</button>
        </div>
      </div>
    } */}
  </>)
}
